import React from "react";
import { Link } from "react-router-dom";

const PostCard: React.FC<{ post: any }> = ({ post }) => {
  const sizes = post.featuredImage?.node?.mediaDetails?.sizes || [];
  const sizeOrder = ["medium_large", "large", "full", "thumbnail"];
  const thumbnailUrl =
    sizeOrder
      .map((name) => sizes.find((s: any) => s.name === name))
      .find(Boolean)?.sourceUrl || post.featuredImage?.node?.sourceUrl;

  const authorName = post.author?.node?.name;

  const formattedDate = new Date(post.date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  let categoryName = "Uncategorized";

  post?.categories?.nodes.forEach((category: any) => {
    if (["Sports", "Variety", "News", "Opinion"].includes(category.name)) {
      categoryName = category.name;
    }
  });

  return (
    <Link to={`/post/${post.slug}`}>
      <div className="flex flex-col h-full bg-white overflow-hidden group">
        <div className="mb-4">
          <p className="text-xs font-bold uppercase tracking-widest text-[#0a5640] text-center mb-3">
            {categoryName}
          </p>

          <div className="relative w-full h-52 overflow-hidden rounded-lg shadow-sm group-hover:shadow-md transition-shadow duration-300 bg-gray-100">
            {thumbnailUrl ? (
              <img
                src={thumbnailUrl}
                alt={post.title}
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <span className="text-gray-400 font-medium">No Image</span>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col flex-grow">
          <h3
            className="text-xl font-heading font-bold mb-3 line-clamp-3 min-h-[4.5rem] group-hover:text-[#0a5640] transition-colors duration-200"
            dangerouslySetInnerHTML={{ __html: post.title }}
          />
          <div className="mt-auto pt-4 border-t border-gray-100">
            {authorName && (
              <p className="text-sm text-gray-600 mb-1">
                <span className="font-semibold text-gray-900">Author:</span>{" "}
                {authorName}
              </p>
            )}
            {post.date && (
              <p className="text-sm text-gray-500 italic">
                <span className="font-semibold text-gray-900 not-italic">
                  Date:
                </span>{" "}
                {formattedDate}
              </p>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PostCard;
